import { toRaw } from "vue"
export const VueFn = {
  log(...args) {
    const argsRaw = args.map(arg => toRaw(arg))
    console.log(...argsRaw)
  }
}